module.exports = __webpack_public_path__ + "static/img/zsdxLogo.ab6a91c0.png";